<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"  
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"  
       style="margin-right: 10px; cursor: pointer;"  
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Entity table removed as not present in original component -->

<!-- STANDARD Modal Body with Tabs -->
<div class="modal-body" [hidden]="minimise">
  <ul class="nav nav-pills" role="tablist">
    @for (tab of tabs; track $index) {
<li [class.active]="tab.id === activeTab">
      <a (click)="onTabChange(tab.id)" style="cursor: pointer;" class="btn-sm">
        {{ tab.name }}
      </a>
    </li>
}
  </ul>

  <div class="tab-content">
    <!-- WWNI Allocation Tab -->
    @if (activeTab === 1) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      <div class="form-horizontal">
        
        <!-- Loading indicator -->
        @if (showFormLoader) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}

        @if (!showFormLoader) {
<div>
          
          <!-- Entity Selection Accordion -->
          <div class="wwni-map-accordion">
            <div class="panel panel-default">
              <div class="panel-heading" (click)="toggleEntityAccordion()" style="cursor: pointer;">
                <h4 class="panel-title">
                  <a class="accordion-toggle">
                    Key: <span class="badge btn-info" style="background-color: #1ca5cf; margin-left: 3px;">Source LEID - Source Tax Code - Source ME</span>
                    <i class="pull-right glyphicon" 
                       [ngClass]="{'glyphicon-chevron-down': entityAccordionOpen, 'glyphicon-chevron-right': !entityAccordionOpen}"></i>
                  </a>
                </h4>
              </div>
              <div class="panel-collapse" [ngClass]="{'collapse': !entityAccordionOpen, 'in': entityAccordionOpen}">
                @if (entityAccordionOpen) {
<div class="panel-body">
                  <div class="entitie-holder">
                    @for (entity of entities; track $index; let i = $index) {
<div class="btn-group dropup pull-left">
                      <button type="button"
                              [ngClass]="{'btn btn-success btn-xs': entity.colorvalue, 'btn btn-xs btn-default': !entity.colorvalue}"
                              (click)="highlight(i)">
                        {{entity.SOURCE_LEID || entity.data?.SOURCE_LEID}} - 
                        {{entity.SOURCE_CDR_NO || entity.data?.SOURCE_CDR_NO}} - 
                        {{entity.SOURCE_ME_CODE || entity.data?.SOURCE_ME_CODE}}
                        <!-- Ikona X po prawej stronie zielonego kafelka -->
                        @if (entity.colorvalue) {
<span 
                              class="fa fa-times" 
                              style="margin-left: 8px; color: white; cursor: pointer;"
                              (click)="removeEntity(i); $event.stopPropagation()"></span>
}
                      </button>
                    </div>
}
                  </div>
                </div>
}
              </div>
            </div>
          </div>

          <!-- Summary Accordion -->
          <div class="wwni-map-accordion">
            <div class="panel panel-default">
              <div class="panel-heading" (click)="toggleSummaryAccordion()" style="cursor: pointer;">
                <h4 class="panel-title">
                  <a class="accordion-toggle">
                    Summary:
                    <i class="pull-right glyphicon" 
                       [ngClass]="{'glyphicon-chevron-down': summaryAccordionOpen, 'glyphicon-chevron-right': !summaryAccordionOpen}"></i>
                  </a>
                </h4>
              </div>
              <div class="panel-collapse" [ngClass]="{'collapse': !summaryAccordionOpen, 'in': summaryAccordionOpen}">
                @if (summaryAccordionOpen) {
<div class="panel-body">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="col-md-3">
                        <label>Total WWNI Per 10K (USD)</label>
                        <div class="input-group noWrap numText">
                          <span class="input-group-addon">USD</span>
                          <input name="cur_adj_amt"
                                 class="form-control input-sm numText"
                                 [(ngModel)]="MAIN_SOURCE_AMT"
                                 type="text" 
                                 readonly>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <label>Total WWNI Allocation (USD) - (a)</label>
                        <div class="input-group noWrap numText">
                          <span class="input-group-addon">USD</span>
                          <input name="cur_adj_amt"
                                 class="form-control input-sm numText"
                                 readonly
                                 [value]="(netIncPerLoss || 0) | number:'1.0-0'"
                                 type="text">
                        </div>
                      </div>
                      <div class="col-md-3" [ngClass]="{'text-danger': changeColorwwni}">
                        <label>Total Compl. BI (USD) - (b)</label>
                        <div class="input-group noWrap numText">
                          <span class="input-group-addon">USD</span>
                          <input name="cur_adj_amt"
                                 class="form-control input-sm numText"
                                 readonly
                                 [value]="(netIncRemain || 0) | number:'1.0-0'"
                                 type="text">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="margin-top: 5px" class="row">
                    <div class="col-md-12">
                      <div class="col-md-3">
                        <label>Total Variance - (c = a-b)</label>
                        <div class="input-group">
                          <span class="input-group-addon">USD</span>
                          <input name="cur_adj_amt" 
                                 class="form-control input-sm numText"
                                 [ngStyle]="totalVariancea != 0 ? {'border': '1px solid #ee3324', 'box-shadow': 'inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 3px rgb(238, 51, 36)'} : {}"
                                 [value]="(totalVariancea || 0) | number:'1.0-0'"
                                 readonly>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <label>Total Variance Explained - (d)</label>
                        <div class="input-group noWrap numText">
                          <span class="input-group-addon">USD</span>
                          <input name="cur_adj_amt"
                                 class="form-control input-sm numText"
                                 readonly
                                 [value]="(totalVarianceAllocateda || 0) | number:'1.0-0'"
                                 type="text">
                        </div>
                      </div>
                      <div class="col-md-3">
                        <label>Total Variance Unexplained - (e = c-d)</label>
                        <div class="input-group noWrap numText">
                          <span class="input-group-addon">USD</span>
                          <input name="cur_adj_amt" 
                                 class="form-control input-sm numText"
                                 [ngStyle]="changeColorVariance ? {'border': '1px solid #ee3324', 'box-shadow': 'inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 3px rgb(238, 51, 36)'} : {'border': '1px solid #33cc33', 'box-shadow': 'inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 3px rgb(51, 204, 51)'}"
                                 readonly
                                 [value]="(totalVarianceRemaina || 0) | number:'1.0-0'"
                                 type="text">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
}
              </div>
            </div>
          </div>

          <!-- Main Data Table -->
          <div>
            <div class="table-responsive">
              <table class="gt-reclass-table table table-hover table-bordered table-striped table-condensed custom-table">
                <thead>
                  <tr>
                    <th></th>
                    <th style="text-align: center;">Sys/LEID/Tax_Code/RPD/ME/Curr/LE Name</th>
                    <th style="text-align: center;">WWNI Allocation (USD)</th>
                    <th style="text-align: center;">Compliance BI Per System (Func Curr)</th>
                    <th style="text-align: center;">Weighted Average Rate</th>
                    <th style="text-align: center;">Compliance BI Per System (USD)</th>
                    <th style="text-align: center;">Variance Amount</th>
                    <th style="text-align: center;">Comments</th>
                  </tr>
                </thead>

                <!-- Main tbody for each mapping item -->
                @for (repoint of mappingList; track $index; let i = $index) {
<tbody>
                  <!-- Main row -->
                  <tr style="width: 100%">
                    <!-- Delete button -->
                    <td style="width: 1%" align="center">
                      <i style="font-size: 24px; cursor: pointer;"
                         class="fa fa-minus-circle color-red"
                         title="Mark Role for Deletion"
                         (click)="removeRepointAmountOne(i)"></i>
                    </td>

                    <!-- Target Key Selection -->
                    @if (!repoint.tagetlistADD) {
<td [ngStyle]="{'width': '29%'}">
                      <input name="cur_adj_amt1"
                             class="form-control ng-pristine ng-untouched ng-valid ng-empty"
                             readonly
                             [(ngModel)]="repoint.TARGET_KEY"
                             type="text">
                      @if (repoint.saveError) {
<div class="form-error-container">Please Select a Key</div>
}
                    </td>
}
                    
                    @if (repoint.tagetlistADD) {
<td [ngStyle]="{'width': '29%'}">
                      <select class="form-control"
                              [(ngModel)]="repoint.TARGET_KEY"
                              (ngModelChange)="targetKey(i, repoint)">
                        <option value="">Select Target Key</option>
                        @for (option of sysLeidDropdownNdata; track $index) {
<option [value]="option">{{option}}</option>
}
                      </select>
                      @if (repoint.saveError) {
<div class="form-error-container">Please Select a Key</div>
}
                    </td>
}

                    <!-- WWNI Allocation Amount -->
                    <td [ngStyle]="{'width': '9%'}">
                      <div class="input-group">
                        <input name="cur_adj_amt" 
                               type="text"
                               class="form-control input-sm numText"
                               required
                               [(ngModel)]="repoint.ALLOCATED_AMT"
                               (ngModelChange)="netINC(i)">
                        <span class="input-group-addon">
                          <i (click)="applyButton(i)" class="fa fa-pencil" style="cursor: pointer;"></i>
                        </span>
                      </div>
                    </td>

                    <!-- Compliance BI Per System (Func Curr) -->
                    @if (repoint.COLUMN_FLAG === 'D' || repoint.COLUMN_FLAG === 'CL') {
<td [ngStyle]="{'width': '9%'}">
                    </td>
}
                    @if (repoint.COLUMN_FLAG === 'F') {
<td [ngStyle]="{'width': '9%'}">
                      <input name="cur_adj_amt" 
                             class="form-control input-sm numText"
                             readonly
                             [value]="repoint.SYSTEM_AMT_LOCAL | number:'1.0-0'"
                             type="text">
                    </td>
}

                    <!-- Weighted Average Rate -->
                    @if (repoint.COLUMN_FLAG === 'D' || repoint.COLUMN_FLAG === 'CL') {
<td [ngStyle]="{'width': '9%'}">
                    </td>
}
                    @if (repoint.COLUMN_FLAG === 'F') {
<td [ngStyle]="{'width': '9%'}">
                      <input name="cur_adj_amt" 
                             class="form-control input-sm numText"
                             readonly
                             [value]="repoint.EXCHANGE_RATE | number:'1.0-4'">
                    </td>
}

                    <!-- Compliance BI Per System (USD) -->
                    <td [ngStyle]="{'width': '9%'}">
                      <input name="cur_adj_amt"
                             class="form-control input-sm numText" 
                             readonly
                             [value]="repoint.SYSTEM_AMT_USD | number:'1.0-0'"
                             type="text">
                    </td>

                    <!-- Variance Amount with conditional styling -->
                    @if (repoint.colorvaluevariance === 'gray') {
<td [ngStyle]="{'width': '10%'}">
                      <div class="input-group">
                        <input name="cur_adj_amt" 
                               class="form-control input-sm numText"
                               readonly
                               [value]="repoint.VARIANCE | number:'1.0-0'"
                               type="text">
                        <span class="input-group-addon">
                          @if (!repoint.open) {
<i 
                             (click)="showDetails(i, true)" 
                             class="fa fa-plus-circle" style="cursor: pointer;"></i>
}
                          @if (repoint.open) {
<i 
                             (click)="showDetails(i, false)" 
                             class="fa fa-minus-circle" style="cursor: pointer;"></i>
}
                        </span>
                      </div>
                    </td>
}
                    
                    @if (repoint.colorvaluevariance === 'green') {
<td [ngStyle]="{'width': '10%'}">
                      <div class="input-group">
                        <input name="cur_adj_amt" 
                               class="form-control input-sm numText"
                               readonly
                               [value]="repoint.VARIANCE | number:'1.0-0'"
                               type="text"
                               style="border: 1px solid #33cc33; box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 3px rgb(51, 204, 51);">
                        <span class="input-group-addon">
                          @if (!repoint.open) {
<i 
                             (click)="showDetails(i, true)" 
                             class="fa fa-plus-circle" style="cursor: pointer;"></i>
}
                          @if (repoint.open) {
<i 
                             (click)="showDetails(i, false)" 
                             class="fa fa-minus-circle" style="cursor: pointer;"></i>
}
                        </span>
                      </div>
                    </td>
}
                    
                    @if (repoint.colorvaluevariance === 'red') {
<td [ngStyle]="{'width': '10%'}">
                      <div class="input-group">
                        <input name="cur_adj_amt" 
                               class="form-control input-sm numText"
                               readonly
                               [value]="repoint.VARIANCE | number:'1.0-0'"
                               type="text"
                               style="background-color: rgb(236, 169, 163);">
                        <span class="input-group-addon">
                          @if (!repoint.open) {
<i 
                             (click)="showDetails(i, true)" 
                             class="fa fa-plus-circle" style="cursor: pointer;"></i>
}
                          @if (repoint.open) {
<i 
                             (click)="showDetails(i, false)" 
                             class="fa fa-minus-circle" style="cursor: pointer;"></i>
}
                        </span>
                      </div>
                    </td>
}

                    <!-- Comments -->
                    <td [ngStyle]="{'width': '14%'}">
                      <input name="cur_adj_amt"
                             class="form-control ng-pristine ng-untouched ng-valid ng-not-empty input-sm"
                             [(ngModel)]="repoint.COMMENTS"
                             type="text">
                    </td>
                  </tr>

                  <!-- Variance Details Row (subrow) -->
                  @if (repoint.open) {
<tr>
                    <td colspan="8">
                      <table class="table table-hover table-bordered table-striped table-condensed-xs custom-table">
                        <thead>
                          <tr>
                            <th style="text-align: center">
                              <i style="font-size: 24px; cursor: pointer;"
                                 class="fa fa-plus-circle color-black"
                                 title="Add Variance"
                                 (click)="varianceAdd(i)"></i>
                            </th>
                            <th style="text-align: center;">Variance Explanation Code</th>
                            <th style="text-align: center;">Sub Category</th>
                            <th style="text-align: center;">Variance Allocated</th>
                            <th style="text-align: center;">Comments</th>
                          </tr>
                          
                          <!-- Variance data rows -->
                          @for (repoint1 of repoint.variancedata; track $index; let j = $index) {
<tr style="width: 100%">
                            <!-- Delete Variance -->
                            <td style="width: 4%" align="center">
                              <i style="font-size: 24px; cursor: pointer;"
                                 class="fa fa-minus-circle color-black"
                                 title="Remove Variance"
                                 (click)="varianceRemove(i, j)"></i>
                            </td>

                            <!-- Variance Explanation Code -->
                            <td style="width: 35%">
                              <select class="form-control"
                                      [(ngModel)]="repoint1.VARIANCE_EXPL_CODE"
                                      (ngModelChange)="varianceExplCode(i, j, repoint1)">
                                <option value="">Select Explanation Code</option>
                                @for (code of expla_code_dropdown; track $index) {
<option [value]="code">{{code}}</option>
}
                              </select>
                              @if (repoint1.varianceError) {
<div class="form-error-container">
                                Please Select a Variance Explanation Code
                              </div>
}
                            </td>

                            <!-- Sub Category -->
                            @if (repoint1.variance_Dropdown_Flag) {
<td style="width: 27%">
                              <select class="form-control"
                                      [(ngModel)]="repoint1.VARIANCE_SUB_CATEFORY">
                                <option value="">Select Sub Category</option>
                                @for (subcat of repoint1.subcateDropdown; track $index) {
<option [value]="subcat">{{subcat}}</option>
}
                              </select>
                              @if (repoint1.VARIANCE_SUB_CATEFORY === '') {
<div class="form-error-container">
                                Please Select a Variance Sub Category Code
                              </div>
}
                            </td>
}
                            
                            @if (!repoint1.variance_Dropdown_Flag) {
<td style="width: 27%">
                              <input type="text" 
                                     class="form-control input-sm" 
                                     [(ngModel)]="repoint1.VARIANCE_SUB_CATEFORY"
                                     readonly>
                            </td>
}

                            <!-- Variance Allocated -->
                            <td style="width: 10%">
                              <div class="input-group">
                                <input type="text" 
                                       name="cur_adj_amt"
                                       class="form-control input-sm numText"
                                       required
                                       [(ngModel)]="repoint1.VARIANCE_ALLOCATED"
                                       (ngModelChange)="calculateVarianceForMapping(i)">
                                <span class="input-group-addon">
                                  <i class="fa fa-pencil" style="cursor: pointer;"></i>
                                </span>
                              </div>
                            </td>

                            <!-- Variance Comments -->
                            <td style="width: 24%">
                              <textarea class="form-control input-sm custom-textarea"
                                        [(ngModel)]="repoint1.VARIANCE_COMMENTS" 
                                        rows="1"></textarea>
                            </td>
                          </tr>
}
                        </thead>
                      </table>
                    </td>
                  </tr>
}
                </tbody>
}
              </table>
            </div>
          </div>

          <!-- Add New Row Button -->
          <div class="row">
            <div class="col-sm-1 col-sm-6 col-xs-12">
              <i style="font-size: 25px; cursor: pointer;"
                 class="fa fa-plus-circle color-green" 
                 title="Add Account"
                 (click)="addRepointVariance()"></i>
            </div>
          </div>

        </div>
}
      </div>
    </div>
}

    <!-- Audit Tab -->
    @if (activeTab === 2) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      <div class="form-horizontal">
        
        <div style="margin-left: 30px; margin-right: 30px; margin-bottom: 30px">
          <div class="divShadow">
            <div class="table-responsive">
              
              @if (crudLoadingaudit) {
<div align="center" class="gt-filter-loading ng-show">
                <i style="color: #e12827;" class="fa fa-spinner fa-spin fa-3x"></i>
              </div>
}
              
              <div class="table-scroll">
                @if (!crudLoadingaudit) {
<table class="gt-reclass-table table table-hover table-bordered table-striped table-condensed sortable custom-table">
                  <thead>
                    <tr>
                      @for (header of viewColumnNames; track $index; let idx = $index) {
<th>
                        <i class="fa pr-5 pointer sticky-col" 
                           [ngClass]="{'fa-sort': sort_key[idx+1] == 0,
                                      'fa-sort-alpha-asc': sort_key[idx+1] == 1,
                                      'fa-sort-alpha-desc': sort_key[idx+1] == 2}"
                           (click)="sortBy(idx+1, sort_key[idx+1])" style="cursor: pointer;"></i> 
                        {{ header }}
                      </th>
}
                    </tr>
                  </thead>

                  @if (noRecords) {
<tbody>
                    <tr>
                      <td class="loading-table" [attr.colspan]="viewColumnNames.length">
                        <div style="margin-top: 20px">
                          <b>No Data Available</b>
                        </div>
                      </td>
                    </tr>
                  </tbody>
}

                  @if (!noRecords) {
<tbody>
                    @for (t of auditData; track $index) {
<tr>
                      <td>{{ t.UPDATED_ON }}</td>
                      <td>{{ t.COMPL_ENTITY }}</td>
                      <td>{{ t.DML_TYPE }}</td>
                      <td>{{ t.OLD_NEW_FLAG }}</td>
                      <td>{{ t.TRANS_TYPE }}</td>
                      <td class="text-right">{{ t.AMOUNT | number:'1.0-0'}}</td>
                      <td>{{ t.COMMENTS }}</td>
                      <td>{{ t.UPDATED_BY }}</td>
                    </tr>
}
                  </tbody>
}
                </table>
}
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
}
  </div>
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  @if (currentTabName != 'Audit') {
<button  
          class="save-button"  
          type="button"  
          [disabled]="isSaveClicked"  
          (click)="save()"> 
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed 
  </button>
}
  @if (currentTabName != 'Audit') {
<button  
          class="reset-button"  
          type="button"  
          (click)="reset()">Reset</button>
}
  <button class="cancel-button"  
          type="button"  
          (click)="cancel()">Cancel</button>
</div>
